<template>
  <div id="app">
    <TheBanner />
    <TheTopAlert />
    <TheMenu />
    <TheFileViewer />
    <router-view />
  </div>
</template>

<script>
import '@/assets/styles/main.scss';
import 'animate.css';
import { mapState } from 'vuex';
import './assets/fonts/MyFontsWebfontsKit.css';
import TheMenu from './components/TheMenu.vue';
import TheFileViewer from './components/TheFileViewer.vue';
import TheTopAlert from './components/TheTopAlert.vue';
import TheBanner from './components/TheBanner.vue';
import Analytics from './analytics';

export default {
  name: 'App',

  metaInfo: {
    title: 'App',
    titleTemplate: '%s | Plateforme Kerala',
  },

  components: {
    TheMenu,
    TheFileViewer,
    TheTopAlert,
    TheBanner,
  },

  data() {
    return {
      identified: false,
    };
  },

  computed: mapState('auth', ['user']),

  created() {
    this.checkCurrentLogin();
  },

  updated() {
    this.checkCurrentLogin();
  },

  methods: {
    checkCurrentLogin() {
      if (this.user) {
        if (!this.identified) {
          this.identified = true;
          Analytics.identify(this.user);
        }
        this.$store.dispatch('auth/fetchCompleteUser');
      }
      if (!localStorage.authorization && !this.$route.meta.public) {
        this.$router.push(`/?redirect=${this.$route.path}`);
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "AvenirLTPro-Roman", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;

  a {
    text-decoration: none;
  }

  button {
    outline: none;
  }
}

a {
  color: inherit;
}
</style>
